import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import './App.css';
import Login from './pages/login';
import Register from './pages/register';
import NgarkoOlimp from './pages/NgarkoOlimp';
import NgarkoWebshop from './pages/NgarkoWebshop';
import OrganizoProvimin from './pages/OrganizoProvimin';
import Aksione from './pages/Aksione';
import HomeLayout from './pages/HomeLayout';
import { Routes, Route, Navigate } from "react-router-dom";
import AdministrateRooms from './pages/AdministrateRooms';
import AdministrateLevels from './pages/AdministrateLevels';
import AdministrateModules from './pages/AdministrateModules';
import Admin from "./pages/Admin";
import OrganizeExam from './pages/OrganizeExam';
import SeatingAssignmentsPage from './pages/SeatingAssignmentsPage';
import MyProfile from './pages/MyProfile';
import PrepareOlymp from './pages/PrepareOlymp';

function App() {
  return (
    <div style={{ paddingBottom: '4rem' }}>
      <Header />

      <main>
        <Routes>
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/rooms" element={<AdministrateRooms />} />
          <Route path="/levels" element={<AdministrateLevels />} />
          <Route path="/modules" element={<AdministrateModules />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/my-profile" element={<MyProfile />} />

          {/* Nested routes inside HomeLayout */}
          <Route path="/" element={<HomeLayout />}>
            <Route index element={<div style={{ width: '900px', margin: 'auto'}}>Welcome! Select a menu item</div>} />
            <Route path="upload-olymp" element={<NgarkoOlimp />} />
            <Route path="upload-files" element={<NgarkoWebshop />} />
            <Route path="prepare-olymp" element={<PrepareOlymp />} />
            <Route path="organize-exam" element={<OrganizeExam />} />
            <Route path="seating-assignments" element={<SeatingAssignmentsPage />} />
            <Route path="my-profile" element={<MyProfile />} />

            <Route path="actions" element={<Aksione />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
